/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

'use strict';

angular.module('prism-ui.components').service('EmailTemplatesService',
    function (this: JS5Object, _: JS5Object, EmailTemplatesResourceFactory: JS5Object,
              PaginationService: JS5Object) {
        this.originalEditData = {};
        const handleGridDataQuery = (gridData, responseHeaders) => {
            PaginationService.parseResponseHeaders(responseHeaders());
            PaginationService.pageData = gridData;
            this.currentPageSize = gridData.length;
        };

        this.getAllEmailTemplates = (queryParams: JS5Object) => {
            return EmailTemplatesResourceFactory.query(queryParams, handleGridDataQuery).$promise;
        };
        this.getEmailTemplate = (emailTemplateId: number, handleGridDataQuery) => {
            return EmailTemplatesResourceFactory.get({emailTemplateId: emailTemplateId}).$promise;
        };
        this.createEmailTemplate = (emailTemplate: JS5Object) => {
            return EmailTemplatesResourceFactory.save(emailTemplate).$promise;
        };
        this.updateEmailTemplate = (emailTemplate: JS5Object) => {
            return EmailTemplatesResourceFactory.update(emailTemplate).$promise;
        };
        this.toggleEmailTemplateHidden = (emailTemplateId: number) => {
            return EmailTemplatesResourceFactory.delete({emailTemplateId: emailTemplateId}).$promise;
        };
    });
